import React from "react"
import {
  Box,
  Flex,
  Heading,
  AspectRatio,
  Image,
  Text,
} from "@theme-ui/components"
import { getProductPath } from "../utils/path"
import { GatsbyImage } from "gatsby-plugin-image"
import { getColor } from "@theme-ui/color"
import themeUiTheme from "../gatsby-plugin-theme-ui"
import { InboundLink } from "./link"
import ArrowRight from "../assets/images/arrow-right.svg"
import ecoLogo from "../images/logo-elettrico.svg"

const ProductThumb = ({ product, parentFamily, parentCategory }) => {
  const fullWidthThumbnail = product.fullWidthThumbnail
  const primary = getColor(themeUiTheme, "primary")
  const dark = getColor(themeUiTheme, "dark")
  // console.log(product.ecommerce)
  return (
    <InboundLink
      className="product-thumb-link"
      sx={{
        color: "dark",
        position: "relative",
        display: "block",
        width: "100%",
        height: "100%",
        "> div": {
          height: "100%",
          maxHeight: "350px",
        },
      }}
      state={{ product }}
      to={getProductPath(product, product.locale, parentFamily, parentCategory)}
    >
      <AspectRatio ratio={1}>
        <Box
          sx={{
            overflow: "hidden",
            backgroundColor: product.socafGear === true ? "darkGrey" : "dark",
            width: "100%",
            height: "100%",
            position: "relative",
            ".gatsby-image-wrapper": {
              overflow: "unset",
              position: "absolute",
              width: [fullWidthThumbnail ? "100%" : "65%"],
              height: [fullWidthThumbnail ? "100%" : "65%"],
              right: [fullWidthThumbnail ? 0 : 3],
              bottom: [fullWidthThumbnail ? 0 : 3],
              "&:before": {
                content: fullWidthThumbnail && "''",
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "dark",
                opacity: fullWidthThumbnail ? 0.3 : 0,
                zIndex: 1,
              },
              img: {
                right: [fullWidthThumbnail ? 0 : 2],
                width: "100%",
                height: "100%",
                objectFit: fullWidthThumbnail ? "cover" : "contain!important",
                objectPosition: "bottom right",
              },
            },
            "&:hover .overlay": {
              width: "120px",
              height: "120px",
              transform: "scale(12,12) translateZ(0)",
            },
          }}
        >
          <Box
            className="overlay"
            sx={{
              position: "absolute",
              width: ["0px"],
              height: ["0px"],
              borderRadius: "50%",
              backgroundColor: "primary",
              right: [0],
              bottom: [0],
              zIndex: fullWidthThumbnail ? 2 : 0,
              transition: "transform 0.4s ease-out, width .6s, height .6s",
            }}
          ></Box>
          {product.thumbnailImage && (
            <GatsbyImage
              image={product.thumbnailImage.gatsbyImageData}
              alt=""
            />
          )}
          {product.eco && (
            <Image
              src={ecoLogo}
              sx={{ position: "absolute", top: 3, right: 3 }}
            />
          )}
          <Flex
            sx={{
              height: "100%",
              position: "absolute",
              top: 0,
              p: [3],
              zIndex: fullWidthThumbnail ? 2 : "unset",
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
              alignContent: "center",
              flexDirection: "column",
            }}
          >
            {product.socafGear === true ? (
              <Flex
                sx={{
                  width: "100%",
                  color: "light",
                  justifyContent: "space-between",
                  alignContent: "center",
                }}
              >
                <Box sx={{ mr: 4 }}>
                  <Heading
                    as="h2"
                    variant="h4"
                    sx={{ mt: 0, color: "light", width: "100%" }}
                  >
                    {product.shortTitle
                      ? product.shortTitle.split("|").map((part, index) => (
                          <div key={index} style={{ display: "block" }}>
                            {part}
                          </div>
                        ))
                      : product.title.split("|").map((part, index) => (
                          <div key={index} style={{ display: "block" }}>
                            {part}
                          </div>
                        ))}
                  </Heading>
                  <Box
                    as="p"
                    sx={{ fontSize: 1, color: "light", width: "70%" }}
                    dangerouslySetInnerHTML={{
                      __html: product.shortDescription,
                    }}
                  />
                </Box>

                <Box
                  as="p"
                  sx={{
                    maxwidth: "35%",
                    minWidth: "30%",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    height: "40px",
                    p: 1,
                    fontWeight: 400,
                    fontSize: [1, 1, 1, 2],
                    alignItems: "center",
                    border: "1px solid",
                    borderRadius: "20px",
                    borderColor: "light",
                  }}
                >
                  by Socaf
                </Box>
              </Flex>
            ) : (
              <Box>
                <Heading
                  as="h2"
                  variant="h4"
                  sx={{ mt: 0, color: "light", width: "100%" }}
                >
                  {product.shortTitle
                    ? product.shortTitle.split("|").map((part, index) => (
                        <div key={index} style={{ display: "block" }}>
                          {part}
                        </div>
                      ))
                    : product.title.split("|").map((part, index) => (
                        <div key={index} style={{ display: "block" }}>
                          {part}
                        </div>
                      ))}
                </Heading>
                <Box
                  as="p"
                  sx={{ fontSize: 1, color: "light", width: "70%" }}
                  dangerouslySetInnerHTML={{
                    __html: product.shortDescription,
                  }}
                />
              </Box>
            )}

            <Flex sx={{ textAlign: "left", color: "light" }}>
              <Box>Scopri di più</Box>
              <Flex
                variant="svg.arrow.light"
                sx={{
                  alignItems: "center",
                  alignContent: "center",
                  width: "24px",
                  height: "24px",
                  ml: [3],
                }}
              >
                <ArrowRight />
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </AspectRatio>
    </InboundLink>
  )
}

export default ProductThumb
